import React from "react";
import footerImage from "../../images/OrviLogo2.png";

function Footer() {
  return (
    <div className="footer w-full text-white pt-4 px-10">
      <div className="flex justify-between items-center  ">
        <div className=" text-center">
          <h6>Copyright © 2025 Orevan. All Rights Reserved.</h6>
        </div>
        <div className="">
          <img className=" w-48" src={footerImage} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Footer;
